import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hiddenInput", "searchInput", "menu", "results", "currentValueButton", "noResults"]

  connect() {
    // Close dropdown when clicking outside
    document.addEventListener("click", this.handleClickOutside.bind(this))
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside.bind(this))
  }

  focus() {
    this.menuTarget.classList.remove("hidden")
    this.search({ target: this.searchInputTarget })
  }

  search(event) {
    const query = event.target.value.toLowerCase().trim()
    const buttons = this.resultsTarget.querySelectorAll("button[data-value]")
    let hasMatches = false
    let hasExactMatch = false

    buttons.forEach(button => {
      const value = button.dataset.value.toLowerCase()
      if (value.includes(query)) {
        button.classList.remove("hidden")
        hasMatches = true
        if (value === query) {
          hasExactMatch = true
        }
      } else {
        button.classList.add("hidden")
      }
    })

    // Show current value button if we have a query and no exact match
    if (query && !hasExactMatch) {
      this.currentValueButtonTarget.classList.remove("hidden")
      this.currentValueButtonTarget.textContent = query
      this.currentValueButtonTarget.dataset.value = query
      this.noResultsTarget.classList.add("hidden")
    } else {
      this.currentValueButtonTarget.classList.add("hidden")
      // Show no results message if there are no matches and no query
      if (!hasMatches && !query) {
        this.noResultsTarget.classList.remove("hidden")
      } else {
        this.noResultsTarget.classList.add("hidden")
      }
    }

    this.menuTarget.classList.remove("hidden")
  }

  select(event) {
    const value = event.currentTarget.dataset.value
    this.hiddenInputTarget.value = value
    this.searchInputTarget.value = value
    this.menuTarget.classList.add("hidden")
    // Dispatch native change event on hidden input to trigger form validation
    this.hiddenInputTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  addNewValue(event) {
    const value = event.currentTarget.dataset.value.trim()
    if (!value) return

    // Get the field name from data attribute
    const fieldName = this.element.dataset.formComboboxFieldNameValue
    if (!fieldName) return

    // Make API request to add new value
    fetch("/tenants/add_custom_field_value", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({
        field_name: fieldName,
        value: value
      })
    }).then(response => {
      if (response.ok) {
        // Add new button to results
        const button = document.createElement("button")
        button.type = "button"
        button.className = "w-full text-left px-3 py-1 text-sm rounded hover:bg-gray-50"
        button.dataset.action = "form-combobox#select"
        button.dataset.value = value
        button.textContent = value
        this.resultsTarget.appendChild(button)

        // Select the new value
        this.hiddenInputTarget.value = value
        this.searchInputTarget.value = value
        this.menuTarget.classList.add("hidden")
        this.hiddenInputTarget.dispatchEvent(new Event("change", { bubbles: true }))
      }
    })
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden")
      // Save the current input value when clicking outside
      this.saveCurrentValue()
    }
  }

  // Save the current input value to the hidden field
  saveCurrentValue() {
    const currentValue = this.searchInputTarget.value.trim()
    const previousValue = this.hiddenInputTarget.value
    this.hiddenInputTarget.value = currentValue
    if (currentValue !== previousValue) {
      this.hiddenInputTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }

  // Handle blur event (when user tabs away or clicks elsewhere)
  blur() {
    this.saveCurrentValue()
    setTimeout(() => {
      this.menuTarget.classList.add("hidden")
    }, 150) // Small delay to allow dropdown clicks
  }
} 